import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import exclamationIcon from 'core/assets/svg/ic-exclamation-16px.svg';
import infoIcon from 'core/assets/svg/ic-info-black.svg';
import { Label } from 'core/components/label';
import useStyles from './inline-callout.styles';

const defaultIcons = { dark: exclamationIcon, light: infoIcon };

/**
 * The Staff Quote Revisit "Inline callout template" (#32313 Figma). The dark variant is a small yellow
 * warning inside a dark card, next to the value it explains (the policy card). The light variant is the
 * beige, larger-text callout used on light backgrounds such as modals, with an info icon unless `icon`
 * says otherwise. Shared so every lane renders the same one.
 */
const InlineCallout = ({ children, className, variant, icon }) => {
  const classes = useStyles();
  return (
    <div className={classNames(classes.callout, classes[variant], className)}>
      <img src={icon ?? defaultIcons[variant]} alt="" className={classes.icon} />
      <Label type={variant === 'light' ? 'body2' : 'body3'} component="p" className={classes.text}>
        {children}
      </Label>
    </div>
  );
};

InlineCallout.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['dark', 'light']),
  icon: PropTypes.string
};

InlineCallout.defaultProps = {
  className: null,
  variant: 'dark',
  icon: null
};

export default InlineCallout;
